// extracted by mini-css-extract-plugin
export default {"select-view":"select-view_select-view__HC-Su","search-icon":"select-view_search-icon__9+Kuv"};